import React, { FC, memo, useMemo } from 'react';
import moment from 'moment';

interface DateTimeFormatProps {
  date: string;
}

const IntlDateFormatComponent: FC<DateTimeFormatProps> = ({ date }) => {
  const momentDate = moment(date);

  const formattedDate = useMemo(() => {
    if (!momentDate.isValid()) {
      return '*Wrong date or format*';
    }

    return new Intl.DateTimeFormat(Intl.NumberFormat().resolvedOptions().locale, {
      weekday: 'short',
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      // TODO: add polyfill to support shortOffset
      timeZoneName: 'short',
    }).format(momentDate.toDate());
  }, [momentDate]);

  return <>{formattedDate}</>;
};

export const IntlDateFormat = memo(IntlDateFormatComponent);
